var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-mu",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00a04d",
    d: "M0 360h640v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151f6d",
    d: "M0 120h640v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ee2737",
    d: "M0 0h640v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd00",
    d: "M0 240h640v120H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMu);
export default __webpack_public_path__ + "static/media/mu.468d5464b2219b1bb9227af74e552fef.svg";
export { ForwardRef as ReactComponent };